:host {
  display: block;
}
/*list-selector*/
gx-ide-list-selector::part(list) {
  display: flex;
  flex-direction: row;
  padding: var(--spacing-padding-xs);
}
/*list-selector-items*/
gx-ide-list-selector-item {
  flex: 1;
  text-align: center;

  .label {
    display: grid;
    inline-size: fit-content;
    &__wrapper {
      grid-template-columns: max-content;
    }
    &__description {
      text-transform: capitalize;
    }
  }

  .pseudo-checkbox {
    position: relative;
    inline-size: var(--control-tiny-size);
    block-size: var(--control-tiny-size);
    outline: 1px solid var(--control-border-color-enabled);
    border-radius: 1px;
  }

  input {
    &:after {
      display: none;
    }
    + .label {
      .label__wrapper {
        display: inline-grid;
        grid-auto-flow: column;
        grid-auto-columns: max-content;
        align-items: center;
        justify-content: center;
      }
    }
  }
  input:checked {
    + .label {
      .pseudo-checkbox {
        outline-color: var(--color-border-primary-default);
      }

      .pseudo-checkbox::before {
        content: "";
        position: absolute;
        inline-size: 100%;
        block-size: 100%;
        inset-inline-start: 0;
        inset-block-start: 0;
        -webkit-mask: no-repeat center / 8px
          url("data:image/svg+xml, <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='currentColor' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>");
        background-color: var(--color-accent-neutral-on-surface);
      }
    }
  }

  /*hover*/
  &:hover {
    input:checked + .label {
    }
  }
}

/*--------------------
Compact size
--------------------*/
:host([compact]) {
  gx-ide-list-selector-item {
    font-size: var(--font-size-body-s);
  }
  .label__wrapper {
    padding: 2px 8px 2px 4px;
    &:before {
      top: 10px;
    }
  }
  .label__universal-slot {
    margin-inline-end: 2px;
  }
}

/*--------------------
All about borders
--------------------*/
:host([no-inner-borders]) {
  gx-ide-list-selector-item {
    border-inline-end: none;
  }
}
